<template>
    <div
        v-show="!isLoading"
        class="AudioPlayControls">
        <AudioSeekBtn
            seekBtnType="backwards"
            :seekStep="seekStep"
            @click.stop="emitEvent('seekBackward')" />

        <AudioPlayBtn
            :isPlaying="isPlaying"
            @click.stop="emitEvent('togglePlay')" />

        <AudioSeekBtn
            seekBtnType="forwards"
            :seekStep="seekStep"
            @click.stop="emitEvent('seekForward')" />
    </div>
</template>

<script>
import AudioPlayBtn from './AudioPlayBtn.vue';
import AudioSeekBtn from './AudioSeekBtn.vue';

export default {
    name: 'AudioPlayControls',
    components: {
        AudioPlayBtn,
        AudioSeekBtn,
    },
    emits: ['seekBackward', 'seekForward', 'togglePlay'],
    props: {
        isPlaying: {
            type: Boolean,
            default: false,
        },
        seekStep: {
            type: Number,
            default: 15,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        emitEvent(name) {
            if (this.disabled) return;

            this.$emit(name);
        },
    },
};
</script>


<style lang="scss" scoped>
.AudioPlayControls {
    display: flex;
    gap: 15px;
    align-items: center;
}
</style>
